import {
    sizeTinyHeader,
    sizeSmallHeader,
    sizeMediumHeader,
    sizeLargeHeader,
    sizeVeryLargeHeader,
    sizeHugeHeader,
    sizeEnormousHeader,
} from './getGroupHeaderForSortBySize.locstring.json';
import loc from 'owa-localize';
import type GroupHeader from '../type/GroupHeader';
import { SizeHeaderId } from '../type/GroupHeaderId';
import type { TableView } from 'owa-mail-list-store';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';

const sizeGroupHeaders: SizeGroupHeader[] = [];

export interface SizeGroupHeader extends GroupHeader {
    greaterThanSize: number;
}

function initializeSizeGroupHeaders() {
    sizeGroupHeaders.push(
        {
            headerId: SizeHeaderId.Tiny,
            headerText: () => loc(sizeTinyHeader),
            greaterThanSize: 0, // There should not exist a row with size 0
        },
        {
            headerId: SizeHeaderId.Small,
            headerText: () => loc(sizeSmallHeader),
            greaterThanSize: 1024 * 10,
        },
        {
            headerId: SizeHeaderId.Medium,
            headerText: () => loc(sizeMediumHeader),
            greaterThanSize: 1024 * 25,
        },
        {
            headerId: SizeHeaderId.Large,
            headerText: () => loc(sizeLargeHeader),
            greaterThanSize: 1024 * 1024,
        },
        {
            headerId: SizeHeaderId.VeryLarge,
            headerText: () => loc(sizeVeryLargeHeader),
            greaterThanSize: 1024 * 1024 * 5,
        },
        {
            headerId: SizeHeaderId.Huge,
            headerText: () => loc(sizeHugeHeader),
            greaterThanSize: 1024 * 1024 * 10,
        },
        {
            headerId: SizeHeaderId.Enormous,
            headerText: () => loc(sizeEnormousHeader),
            greaterThanSize: 1024 * 1024 * 25,
        }
    );
}

/**
 * Get GroupHeader for row
 * @param rowKey rowKey for which we want to lookup time group range
 * @param tableView tableView
 * @return group header
 */
export default function getGroupHeaderForSortBySize(
    rowKey: string,
    tableView: TableView
): GroupHeader {
    if (sizeGroupHeaders.length == 0) {
        initializeSizeGroupHeaders();
    }

    const rowSize = MailRowDataPropertyGetter.getSize(rowKey, tableView);
    for (let i = sizeGroupHeaders.length - 1; i >= 0; i--) {
        if (rowSize > sizeGroupHeaders[i].greaterThanSize) {
            return sizeGroupHeaders[i];
        }
    }

    const errorString = 'getGroupHeaderForSortBySizeMissingSize';
    /* eslint-disable-next-line owa-custom-rules/no-dynamic-event-names  -- (https://aka.ms/OWALintWiki)
     * Datapoint's event names can only be string literals (variables, string templates and other dynamic names are not accepted).
     *	> Datapoint's event names can only be a string literals as the first argument of the function call. */
    logUsage(errorString);
    trace.warn(errorString);
    return {
        headerText: sizeGroupHeaders[0].headerText,
        headerId: sizeGroupHeaders[0].headerId,
    };
}
